module.exports = __webpack_public_path__ + "static/media/clients-04.cdf0e500.svg";